import type {
	GridColumnProps,
	GridCustomCellProps,
} from "@tql/ui-components-react/kendo/grid";
import { useMemo, useRef } from "react";

import { GridTd } from "~/shared/components/trax-grid/grid-td/grid-td.tsx";
import { formatCurrency } from "~/shared/utils/string-fns.ts";

import { DeleteCell } from "../components/delete-cell/delete-cell.tsx";
import { PaymentAmountCell } from "../components/payment-amount-cell/payment-amount-cell.tsx";

type UseGridColumnsProps = {
	onAmountChange: (invoiceId: string, amount: number) => void;
	onDeleteInvoice: (invoiceId: string) => void;
};

export const useGridColumns = ({
	onAmountChange,
	onDeleteInvoice,
}: UseGridColumnsProps): GridColumnProps[] => {
	const onAmountChangeRef = useRef(onAmountChange);
	const onDeleteInvoiceRef = useRef(onDeleteInvoice);

	onAmountChangeRef.current = onAmountChange;
	onDeleteInvoiceRef.current = onDeleteInvoice;

	return useMemo(
		() => [
			{
				field: "custPO",
				title: "Customer PO #",
				menu: true,
				show: true,
			},
			{
				field: "poNumber",
				title: "TQL PO #",
				menu: true,
				show: true,
			},
			{
				field: "balance",
				title: "Balance",
				menu: true,
				show: true,
				cells: {
					data: (props: GridCustomCellProps) => (
						<GridTd tdProps={props.tdProps}>
							{formatCurrency(
								(props.dataItem as { balanceAmt: number }).balanceAmt,
							)}
						</GridTd>
					),
				},
			},
			{
				field: "payAmount",
				title: "Pay Amount (USD)",
				menu: true,
				show: true,
				cells: {
					data: (props: GridCustomCellProps) => (
						<GridTd tdProps={props.tdProps}>
							<PaymentAmountCell
								{...props}
								onAmountChange={(val) =>
									onAmountChangeRef.current(
										String(
											(props.dataItem as { invoiceID: string | number })
												.invoiceID,
										),
										val,
									)
								}
							/>
						</GridTd>
					),
				},
			},
			{
				field: "",
				title: "",
				menu: true,
				show: true,
				width: 50,
				cells: {
					data: (props: GridCustomCellProps) => (
						<DeleteCell
							{...props}
							onDelete={(id) => onDeleteInvoiceRef.current(id)}
						/>
					),
				},
			},
		],
		[],
	);
};
